module.exports = __webpack_public_path__ + "static/img/4-CN.5daf47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/4-CN.png
// module id = lZQr
// module chunks = 1